import React from 'react'

export function CaretIcon() {
    return (
        <svg viewBox="0 0 16 16" aria-hidden="true">
            <path d="m4 6 4 4 4-4z" />
        </svg>
    )
}
